module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-SPORT-1.39b64a64.jpg";